import {validateDesign,type Product,type Design} from '../../packages/design-schema/index';

type Request=(action:string,payload:object)=>Promise<any>;
export async function saveEditorDesign({product,design,label,admin,approved,mappings,prepare,isCurrent,request}:{product:Product;design:Design;label:string;admin:boolean;approved:boolean;mappings:Record<string,string>;prepare:()=>Product|undefined;isCurrent:()=>boolean;request:Request}) {
  const ensureCurrent=()=>{if(!isCurrent())throw new Error('The design changed while saving. Save again to update the customer template and print proof.');};
  let configured=product;
  if(admin){
    const template=prepare();
    if(!template)throw new Error('Add and style the customer text fields before saving the template.');
    validateDesign(template,design);
    ensureCurrent();
    const result=await request('configure',{product:{...template,verified:approved},mappings});
    ensureCurrent();
    if(!result?.product)throw new Error('WordPress did not confirm the saved product template.');
    configured=result.product;
  }
  validateDesign(configured,design);
  ensureCurrent();
  const revision=await request('save',{design,label});
  ensureCurrent();
  if(!revision?.id||!Array.isArray(revision.files))throw new Error('WordPress did not confirm the saved print revision.');
  const status=admin
    ? configured.verified
      ? 'Customer text template saved. Review the print proof. Sales also require the Printful readiness check.'
      : 'Draft customer text template saved. It is not approved for sale, so Add to basket remains unavailable.'
    : configured.verified
      ? 'Saved. Review the print proof, then add to your basket.'
      : 'Draft saved. This product is not approved for sale.';
  return {product:configured,revision,status};
}
